var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LoaderWrapper',{attrs:{"requires":[_vm.currentInode]}},[_c('Header'),_c('FolderForm',{attrs:{"folder":_vm.newFolder}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }